/* 
    Importing the srevice calls and Dependencies
    for the Image upload 
*/
import * as service from "./ImageUpload.service";

export default {
  name: "ImageUpload",
  data() {
    return {
      snackBar: false,
      snackMessage: "",
      uploadImageName: "",
      files: "",
      image: "",
      imageBack: "",
      imageURL: "",
      isLoader: false,
      snackColor: "success",
      cropped: null
    };
  },
  mounted() {
    this.bind();
    this.$on("imageUploaded", function(imageData) {
      this.imageBack = imageData;
      this.bind();
    });
  },
  methods: {
    onChange(e) {
      this.files = e.target.files;
      let imgName = this.files[0].name;
      this.uploadImageName = imgName.replace(/\.[^.]+$/, "");
      this.createFile(this.files[0]);
    },
    createFile(file) {
      var type = file.type;
      var size = file.size;
      var name = file.name;
      if (!file.type.match("image.*")) {
        this.snackMessage = "Invalid image format";
        this.snackColor = "warning";
        this.uploadImageName = "";
        this.snackBar = true;
        this.image = "";
        this.files = "";
        document.getElementById("HdnUploadFile").value = "";
        return;
      }
      if (size == 0) {
        this.snackMessage = "File Empty";
        this.uploadImageName = "";
        this.snackColor = "warning";
        this.snackBar = true;
      }
      if (size > 10485760) {
        this.snackMessage = "You have exceeded the maximum image size of 10 MB";
        this.uploadImageName = "";
        this.image = "";
        this.files = "";
        document.getElementById("HdnUploadFile").value = "";
        this.snackColor = "warning";
        this.snackBar = true;
        return;
      }
      if (this.imageBack) {
        this.image = this.imageBack;
      }

      var reader = new FileReader();
      var vm = this;

      reader.onload = function(e) {
        vm.image = e.target.result;
        vm.$emit("imageUploaded", e.target.result);
      };
      reader.readAsDataURL(file);
    },

    SaveImage() {
      let context = this;
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result.
      let options = {
        type: "blob",
        size: "original",
        format: "jpeg",
        quality: 0.6,
        circle: false
      };
      this.isLoader = true;

      this.$refs.croppieRef.result(options, output => {
        this.cropped = output;

        const imageData = {
          Name: this.uploadImageName,
          Blob: this.cropped
        };

        if (imageData.Name) {
          service.UploadImage(imageData).then(snapshot => {
            context.snackMessage = "Uploaded successfully";
            context.snackColor = "success";
            context.snackBar = true;
            context.uploadImageName = "";
            document.getElementById("HdnUploadFile").value = "";
            snapshot.ref.getDownloadURL().then(downloadurl => {
              context.imageURL = downloadurl;
              context.isLoader = false;
              context.$refs.croppieRef.refresh();

              //emitting to the Profile component to save the selected image to fire storage
              context.$router.app.$emit("ImageUploadTrigger", context.imageURL);
            });
          });
        } else {
          context.snackMessage = "Please select an image to upload";
          context.snackColor = "warning";
          context.snackBar = true;
          context.isLoader = false;
        }
      });
    },

    CancelCroppie() {
      this.$refs.croppieRef.refresh();
      this.uploadImageName = "";
      this.image = "";
      this.files = "";
      document.getElementById("HdnUploadFile").value = "";
      //emitting to the Profile component to set the isImageEdit false
      this.$router.app.$emit("CancelImageCroppie");
    },

    //=========Cropiee=========
    bind() {
      // Just like what we did with .bind({...}) on
      // the mounted() function above.
      this.$refs.croppieRef.bind({
        url: this.image
      });
    },
    result(output) {
      this.cropped = output;
    },
    update(val) {
      //   console.log(val);
    },
    rotate(rotationAngle) {
      // Rotates the image
      if (this.files) {
        this.$refs.croppieRef.rotate(rotationAngle);
      }
    }
  }
};
